import "bkoi-gl/dist/style/bkoi-gl.css";
// import "mapbox-gl/dist/mapbox-gl.css";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import ReactDOM from "react-dom/client";
import "react-quill/dist/quill.snow.css";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import store from "./app/store";
import Loader from "./components/ui/Loader";
import { AUTH_LOCALSTORAGE_NAME } from "./constants/constants";
import { userLoggedIn } from "./features/auth/authSlice";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.css";
import "./styles/override.css";

// comment

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// export const keycloak = new Keycloak({
//   url: process.env.REACT_APP_KEYCLOAK_URL || "https://sso.dev-sheba.xyz",
//   realm: process.env.REACT_APP_KEYCLOAK_REALM || "master",
//   clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "digigo",
// });
export const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || "https://sso.dev-sheba.xyz",
  realm: process.env.REACT_APP_KEYCLOAK_REALM || "master",
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "digigo",
});

root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      onLoad: "check-sso",
      pkceMethod: "S256",
      checkLoginIframe: false,
    }}
    onEvent={async (event, error) => {
      console.log(error);

      if (event === "onTokenExpired") {
        try {
          await keycloak.updateToken(30);
        } catch (refreshErr) {
          console.error("Keycloak token refresh failed:", refreshErr);
        }
      }
    }}
    onTokens={(tokens) => {
      const accessToken = tokens?.token;

      if (!accessToken) return;

      const authPayload = {
        access_token: accessToken,
        refresh_token: tokens?.refreshToken,
      };

      localStorage.setItem(AUTH_LOCALSTORAGE_NAME, JSON.stringify(authPayload));
      store.dispatch(userLoggedIn({ access_token: accessToken }));
    }}
    LoadingComponent={<Loader />}
  >
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </ReactKeycloakProvider>,
);

// root.render(
//   <ReactKeycloakProvider
//     authClient={keycloak}
//     initOptions={{
//       onLoad: "login-required",
//       pkceMethod: "S256",
//       checkLoginIframe: false,
//       redirectUri: window.location.origin + "/",
//     }}
//     onEvent={(event, error) => {
//       console.log(error);
//     }}
//     LoadingComponent={<Loader />}
//   >
//     <Provider store={store}>
//       <Router>
//         <App />
//       </Router>
//     </Provider>
//   </ReactKeycloakProvider>
// );

reportWebVitals();
